import { render, staticRenderFns } from "./LoginPass.vue?vue&type=template&id=febe3868&scoped=true&"
import script from "./LoginPass.vue?vue&type=script&lang=js&"
export * from "./LoginPass.vue?vue&type=script&lang=js&"
import style0 from "./LoginPass.vue?vue&type=style&index=0&id=febe3868&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febe3868",
  null
  
)

export default component.exports